import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = {
  class: "navbar navbar-light navbar-expand-md mt-5",
  style: {"background-color":"rgba(0, 0, 0, 0.03)","border":"1px solid rgba(0, 0, 0, 0.125)","border-bottom":"0"},
  role: "navigation"
}
const _hoisted_7 = { class: "navbar-nav ml-auto mr-2" }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = { class: "navbar-form" }
const _hoisted_10 = { class: "btn-group" }
const _hoisted_11 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = {
  class: "form-inline my-2 my-lg-0",
  role: "search"
}
const _hoisted_14 = { class: "table table-bordered table-hover" }
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_17 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_18 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_19 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_20 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

import { computed, onMounted, ref, watch, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import PortfolioScenarioNavigation from '@Quest/PortfolioScenarios/Components/PortfolioScenarioNavigation.vue'
    import { ProjectAcceptance } from '@common/types'

    import { useApprovalPageQueryV1 } from '@Quest/PortfolioScenarios/queries-vue-composables'

    import
    {
        useApproveScenarioCommandV1,
        useApproveScenarioProjectCommandV1,
        useUpdatePortfolioScenarioCommandV1
    } from '@Quest/PortfolioScenarios/commands-vue-composables'

    import type { ApprovalPageReadModel, ApprovalProjectReadModel } from '@Quest/PortfolioScenarios/readmodels'


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ApprovalPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))


    // ======================
    // Query
    // ======================

    const {
        runApprovalPageQueryV1,
        modelApprovalPageQueryV1
    } = useApprovalPageQueryV1(workspaceId, tchProjectId, scenarioId)

    const rm = modelApprovalPageQueryV1 as Ref<ApprovalPageReadModel | null>
    const portfolioId = computed(() => rm.value?.PortfolioId)


    // ======================
    // Commands
    // ======================

    const {
        invokeApproveScenarioCommandV1,
        onSucceedApproveScenarioCommandV1,
    } = useApproveScenarioCommandV1(workspaceId, portfolioId, scenarioId)

    const {
        invokeApproveScenarioProjectCommandV1,
        onSucceedApproveScenarioProjectCommandV1
    } = useApproveScenarioProjectCommandV1(workspaceId, portfolioId, scenarioId)



    // ======================
    // Local State
    // ======================

    const searchPhrase = ref<string | null>(null)
    const filter = ref<string>('All')

    const projectsView = computed<ApprovalProjectReadModel[]>(() =>
    {
        let view = [...(rm.value?.Projects ?? [])]

        if (searchPhrase.value)
        {
            const phrase = searchPhrase.value.toLowerCase()
            view = view.filter(a => a.Name.toLowerCase().indexOf(phrase) > -1)
        }

        switch (filter.value)
        {
            case 'All':
                return view

            case 'Accepted':
                return view.filter(a => a.Acceptance === ProjectAcceptance.Accepted)

            case 'Rejected':
                return view.filter(a => a.Acceptance === ProjectAcceptance.Rejected)

            case 'TBD':
                return view.filter(a => a.Acceptance === ProjectAcceptance.TBD)

            default:
                return []
        }
    })


    // ======================
    // Actions
    // ======================

    function handleApproveScenarioCommand()
    {
        if (confirm("Are you sure you want to approve all changes to projects in this scenario?"))
        {
            invokeApproveScenarioCommandV1()
        }
    }

    function handleApproveScenarioProjectCommand(projectId: string)
    {
        invokeApproveScenarioProjectCommandV1({
            ProjectId: projectId
        })
    }

    function onSelected()
    {
        runApprovalPageQueryV1()
    }

    onMounted(() =>
    {
        document.title = "Portfolio Plan - Approval"
        runApprovalPageQueryV1()
    })

    onSucceedApproveScenarioProjectCommandV1(() =>
    {
        runApprovalPageQueryV1()
        alert("Updated")
    })

    onSucceedApproveScenarioCommandV1(() =>
    {
        runApprovalPageQueryV1()
        alert("Updated")
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, _toDisplayString(_unref(rm).PortfolioName) + " / " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[5] || (_cache[5] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Plan: Approval", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(PortfolioScenarioNavigation, {
                portfolioId: _unref(rm).PortfolioId,
                corporateScenarioUrl: _unref(rm).CorporateScenarioUrl,
                onSelected: onSelected
              }, null, 8 /* PROPS */, ["portfolioId", "corporateScenarioUrl"])
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("nav", _hoisted_6, [
            _createElementVNode("ul", { class: "navbar-nav" }, [
              _createElementVNode("li", { class: "dropdown mr-2" }, [
                _createElementVNode("div", { class: "navbar-form" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-success",
                    onClick: handleApproveScenarioCommand
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "fa-solid fa-pen-nib" }, null, -1 /* CACHED */),
                    _createTextVNode(" Update all ", -1 /* CACHED */)
                  ]))])
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", _hoisted_11, "View: " + _toDisplayString(filter.value), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (filter.value = 'All'))
                      }, "All"),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "dropdown-header" }, "Filter by status:", -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (filter.value = 'TBD'))
                      }, "TBD"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (filter.value = 'Accepted'))
                      }, "Accepted"),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (filter.value = 'Rejected'))
                      }, "Rejected")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control mr-sm-2",
                type: "search",
                placeholder: "Search",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchPhrase).value = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, searchPhrase.value]
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_14, [
            _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Project"),
                _createElementVNode("th", null, "P&L"),
                _createElementVNode("th", null, "Acceptance"),
                _createElementVNode("th", null, "Start date"),
                _createElementVNode("th", null, "Commitment date"),
                _createElementVNode("th", null, "Status"),
                _createElementVNode("th", { style: {"width":"120px"} })
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectsView.value, (a) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: a.Id
                }, [
                  _createElementVNode("td", null, [
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [
                      _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                    ])), [
                      [_directive_sanitizedHref, `/#/portfolio/alternative/dashboard/${workspaceId.value}/${tchProjectId.value}/${a.Id}`]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    (a.PlanId)
                      ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" View ", -1 /* CACHED */)
                        ]))])), [
                          [_directive_sanitizedHref, `/#/q/project/pnl/${workspaceId.value}/${tchProjectId.value}/${a.Id}/${a.PlanId}`]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" NA ", -1 /* CACHED */)
                        ]))])), [
                          [_directive_sanitizedHref, `/#/q/project/summary/${workspaceId.value}/${tchProjectId.value}/${a.Id}`]
                        ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(a.Acceptance), 1 /* TEXT */),
                  _createElementVNode("td", {
                    class: _normalizeClass({'table-warning': a.ScenarioStartDateString !== a.PortfolioStartDateString})
                  }, [
                    _createTextVNode(_toDisplayString(a.ScenarioStartDateString), 1 /* TEXT */),
                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    (a.PortfolioStartDateString)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_18, " (" + _toDisplayString(a.PortfolioStartDateString) + ") ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("td", {
                    class: _normalizeClass({'table-warning': a.ScenarioCommitmentDateString !== a.PortfolioCommitmentDateString})
                  }, [
                    _createTextVNode(_toDisplayString(a.ScenarioCommitmentDateString), 1 /* TEXT */),
                    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    (a.PortfolioCommitmentDateString)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_19, " (" + _toDisplayString(a.PortfolioCommitmentDateString) + ") ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("td", {
                    class: _normalizeClass({'table-warning': a.ScenarioKanbanStatus !== a.PortfolioKanbanStatus})
                  }, [
                    _createTextVNode(_toDisplayString(a.ScenarioKanbanStatus), 1 /* TEXT */),
                    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    (a.PortfolioKanbanStatus)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_20, " (" + _toDisplayString(a.PortfolioKanbanStatus) + ") ", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */),
                  _createElementVNode("td", null, [
                    (a.IsApproved === false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-outline-success",
                          onClick: ($event: any) => (handleApproveScenarioProjectCommand(a.Id))
                        }, " Update ", 8 /* PROPS */, _hoisted_21))
                      : _createCommentVNode("v-if", true),
                    (a.IsApproved === true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-success",
                          disabled: "",
                          onClick: ($event: any) => (handleApproveScenarioProjectCommand(a.Id))
                        }, " Update ", 8 /* PROPS */, _hoisted_22))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1 /* CACHED */))
  ]))
}
}

})